<template>
  <div class="user_select_wraper" @click="openValue">
    <div
      class="back_ground_wraper"
      :class=" dselectData.selectShow === true ? 'back_ground_wraper_active':''"
    ></div>

    <div class="input_select_wraper">{{dselectData.value}}</div>

    <div class="list_wraper" v-show="dselectData.selectShow">
      <ul>
        <li
          @click.stop="getvalue(index,item)"
          v-for="(item,index) in dselectData.tableData"
          :key="item.index"
        >{{ item.name }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dselectData: {
        tableData: this.selectData.tableData,
        selectShow: false,
        value: this.selectData.value
      }
    };
  },
  props: {
    selectData: Object
  },
  methods: {
    openValue() {
      //   console.log("22222222");
      this.dselectData.selectShow = !this.dselectData.selectShow;
    },
    getvalue(index, item) {
      //   console.log("1111111111");
      this.dselectData.value = item.name;
      this.dselectData.selectShow = false;
      this.$emit("selectValueEvent", this.dselectData.value);
    }
  }
};

/**
 * 使用方法：
 *       <!-- ////下拉选择框 -->
      <div class="select_scene_rule_wraper">
        <user-select :selectData="selectData" @selectValueEvent = "selectValueEvent"></user-select>
      </div>

数据
  selectData: { ////下拉选择框的数据
        tableData: [
          {
            name: "默认排序"
          },
          {
            name: "时间排序"
          },
          {
            name: "名称排序"
          }
        ],
        value: "默认排序"
      }
事件
    selectValueEvent(value){
      ///下拉选择框传来的值
      // console.log(this.selectData.value)
      this.selectData.value = value;
      // console.log(this.selectData.value)

    }

定位
.select_scene_rule_wraper {
  position: absolute;
  top: 105px;
  right: 50px;

}

 */
</script>

<style>
.user_select_wraper {
  /* margin: 200px; */
  display: inline-block;
  /* width: 100%; */
  position: relative;
  background-color: transparent;
  cursor: pointer;
}
.back_ground_wraper {
  position: fixed;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  z-index: -1;
}
.back_ground_wraper_active {
  z-index: 2;
}
.input_select_wraper {
  width: 120px;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  color: #40a8fb;
  box-sizing: border-box;
  padding: 0px 10px;
  border: 1px solid #40a8fb;
  border-radius: 10px;

  background-color: #ffffff;
  position: relative;
  z-index: 3;
}

.list_wraper {
  width: 118px;
  border: 1px solid #40a8fb;
  border-radius: 10px;
  overflow: hidden;
  position: absolute;
  z-index: 3;
}
.list_wraper ul li {
  list-style: none;
  width: 100%;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  cursor: pointer;
  padding-left: 10px;
  background-color: #ffffff;
}
.list_wraper ul li:hover {
  background-color: #f2f2f2;
  color: #40a8fb;
}
.input_select_wraper::after {
  content: "";
  display: inline-block;
  position: absolute;
  border: 7px solid;
  border-color: #40a8fb transparent transparent transparent;

  top: 15px;
  right: 10px;
}
</style>